import React from 'react'

const AboutUs = () => {
  return (
    <h1>This is the ABout Us page</h1>
  )
}

export default AboutUs